<template>
    <div class="affiliate">

    </div>
</template>

<script>

    Vue.use(require('vue-cookies'));

    export default {

        props: ["model"],



        methods: {

            init: function () {

                this.model.s_ref = null;

                this.check_if_has_affiliate_cookie();

            },

            check_if_has_affiliate_cookie()
            {
                var s_ref = this.$cookies.get("s_ref");

                if(s_ref !== null) {
                    this.model.s_ref = s_ref;
                }
            }
        }


    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/Affiliate.vue